export default __webpack_public_path__ + "static/media/icon-adhoc.98675921.svg";